import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Automatically redirect to admin login
    navigate('/admin/login', { replace: true });
  }, [navigate]);

  return (
    <div className="home-page">
      <div className="hero-section">
        <div className="container">
          <div className="hero-content">
            <p>Redirecting to admin portal...</p>
          </div>
        </div>
      </div>

      <style jsx>{`
                .home-page {
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(135deg, var(--primary-bg) 0%, #d6e7ff 100%);
                }

                .hero-content {
                    text-align: center;
                }

                .hero-content p {
                    font-size: 18px;
                    color: var(--text-secondary);
                }
            `}</style>
    </div>
  );
};

export default HomePage;